/**
 * Heure toujours en 24 h. Les champs natifs `type="time"` et `type="datetime-local"` suivent la langue du navigateur
 * (AM/PM en anglais) : on saisit l'heure dans un champ texte, la date reste native (sans AM/PM).
 * Valeurs émises au format des champs natifs : `HH:MM` et `AAAA-MM-JJTHH:MM`, ou `''` tant que la saisie est incomplète.
 */
export function parseTime24(text: string): string | null {
  const match = /^(\d{1,2})(?:\s*[:hH]?\s*(\d{2}))?$/.exec(text.trim())
  if (!match) return null
  const hours = Number(match[1])
  const minutes = Number(match[2] ?? '0')
  if (hours > 23 || minutes > 59) return null
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}
